import { render, staticRenderFns } from "./MetaInfoImage.vue?vue&type=template&id=87d4f194&scoped=true"
import script from "./MetaInfoImage.vue?vue&type=script&lang=js"
export * from "./MetaInfoImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d4f194",
  null
  
)

export default component.exports